import React from 'react';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';

import intlEquipped, { propTypes as i18nPropTypes } from '../../hocs/intlEquipped';
import { getStaticFilePath } from '../../util/uri';

import { ContainedButton, OutlinedButton } from '../Buttons';
import Icon from '../Icon';

const InlineError =
    ({ onClickHandlers: { cancel, retry }, title, text, imagePath, i18n: { formatMessage }, theme }) => (
        <div className={ theme.error }>
            <Icon src={ getStaticFilePath(imagePath) } className="image" theme={ theme } />
            <h1 className={ theme.title }>{ title }</h1>
            <p className={ theme.message }>{ text || formatMessage('loader.error.text') }</p>
            <div className={ theme.buttons }>
                {
                    cancel && (
                        <OutlinedButton
                            text={ formatMessage('loader.error.buttons.cancel') }
                            onClick={ cancel }
                            theme={ theme }
                        />
                    )
                }
                {
                    retry && (
                        <ContainedButton
                            text={ formatMessage('loader.error.buttons.retry') }
                            onClick={ retry }
                            theme={ theme }
                        />
                    )
                }
            </div>
        </div>
    );

const ModalError = ({ theme, ...props }) => (
    <Paper className={ theme.modalError }>
        <InlineError theme={ theme } { ...props } />
    </Paper>
);

const Error = ({ inline = false, ...props }) => (
    inline
        ? <InlineError { ...props } />
        : <ModalError { ...props } />
);

InlineError.propTypes = {
    onClickHandlers: PropTypes.shape({
        cancel: PropTypes.func,
        retry: PropTypes.func,
    }).isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
    imagePath: PropTypes.string,
    i18n: i18nPropTypes,
    theme: PropTypes.shape({}),
};

Error.propTypes = {
    onClickHandlers: PropTypes.shape({
        cancel: PropTypes.func,
        retry: PropTypes.func,
    }).isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
    imagePath: PropTypes.string,
    i18n: i18nPropTypes,
    theme: PropTypes.shape({}),
    inline: PropTypes.bool,
};

Error.defaultProps = {
    text: '',
    title: 'Oops',
    imagePath: '/images/error.svg',
    theme: {},
};

export default intlEquipped(Error);
